import { Reducer } from "redux";
import { produce } from "immer";

import { FLOOR_TRADE_DEVIATION_MAGNITUDES_LOADED, FloorTradeDeviationMagnitudesLoadedEvent } from "../../../events/loaded/projects/floor_trade_deviation_magnitudes_loaded";

export type FloorTradeDeviationMagnitudes = { [floorFirebaseId: string]: { [tradeCode: string]: number } }

export type FloorTradeDeviationMagnitudesStore = {
  byFirebaseProjectId: { [projectId: string]: FloorTradeDeviationMagnitudes }
  currentScanByFirebaseProjectId: { [projectId: string]: FloorTradeDeviationMagnitudes }
}

const reduceFloorTradeDeviationMagnitudes: Reducer<FloorTradeDeviationMagnitudesStore, FloorTradeDeviationMagnitudesLoadedEvent> = (
  magnitudesStore: FloorTradeDeviationMagnitudesStore = {
    byFirebaseProjectId: {},
    currentScanByFirebaseProjectId: {},
  },
  event
) => {
  return produce<FloorTradeDeviationMagnitudesStore>(magnitudesStore, (draft) => {
    if (!draft.byFirebaseProjectId) {
      draft.byFirebaseProjectId = {};
    }
    switch (event.type) {
      case FLOOR_TRADE_DEVIATION_MAGNITUDES_LOADED: {
        if (event.payload.currentScan) {
          draft.currentScanByFirebaseProjectId[event.payload.projectId] = event.payload.magnitudes;
        } else {
          draft.byFirebaseProjectId[event.payload.projectId] = event.payload.magnitudes;
        }
        return draft;
      }
      default: {
        return draft;
      }
    }
  });
};

export default reduceFloorTradeDeviationMagnitudes;
